import type { ReactNode } from 'react'

import Box from '@mui/material/Box'
import type { SxProps } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'

interface AmountPillProps {
  /** Pill content (amount / price string). */
  children: ReactNode
  /** Horizontal padding in px (Figma varies: 16 inline, 10 in the hero). */
  px?: number
  sx?: SxProps
}

/**
 * A dark rounded amount/price pill: `text.primary` surface with
 * `primary.contrastText` `subtitle2` text. Shared by MerchantHighlightCard and
 * SubscriptionHeroCard.
 */
const AmountPill = ({ children, px = 16, sx }: AmountPillProps) => (
  <Box
    sx={{
      alignItems: 'center',
      alignSelf: 'flex-start',
      bgcolor: 'text.primary',
      borderRadius: 999,
      display: 'flex',
      px,
      py: 2,
      ...sx,
    }}
  >
    <Text color="primary.contrastText" variant="subtitle2">
      {children}
    </Text>
  </Box>
)

export default AmountPill
